import React from 'react';
import { ClassAssembly6F2025 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly6F2025/>;
  };
  
  export default ClassAssemblyPage;